module.exports = __webpack_public_path__ + "media/images/front/pc/atopy-control-check/bg01-5e127e6fad206fd3542728b43792fd2a.png";